import { MessagingBase } from "./MessagingBase";
/**
 * A Service allows to send and receive messages from other modules. The difference to a Module is, that a system can
 * either just use the BusConnection of a module that is passed to the System during its creation
 * ```TS
 * class MySystem {
 *  constructor(connectionFromModule: BusConnection) {
 *    super(connectionFromModule)
 *  }
 * }
 * ```
 * or specify its own BusConnection if necessary
 * ```TS
 * class MySystem {
 *  constructor() {
 *    super(busService.connection("MySystem"))
 *  }
 * }
 * ```
 *
 * Another important distinction is that modules have additional life-cycle methods which systems don't have.
 *
 * You can use decorators to specify message handlers. For further information check out @MessageHandler, @FacetHandler,
 * etc. in `messageHandlerDecorators.ts`
 */
export class Service extends MessagingBase {
    // Explicitly specify trivial constructor to show that the user has to provide the connection from the outside
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(connection) {
        super(connection);
    }
}
